module.exports = __webpack_public_path__ + "static/media/favicon-SPM.a5c881a4.ico";